import { render, staticRenderFns } from "./prodotti.vue?vue&type=template&id=081b68d0"
import script from "./prodotti.vue?vue&type=script&lang=js"
export * from "./prodotti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports